var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 9.8564C20.0003 12.5058 19.5562 14.6549 19.0083 14.6549C18.4604 14.6549 18.0166 12.5064 18.0166 9.8564C18.0166 7.2064 18.4606 5.05786 19.0083 5.05786C19.556 5.05786 20.0003 7.2062 20.0003 9.8564Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 9.85646C17.4688 12.8142 16.2061 15.2129 14.6485 15.2129C13.0908 15.2129 11.8281 12.8142 11.8281 9.85646C11.8281 6.8987 13.0906 4.5 14.6483 4.5C16.2059 4.5 17.4686 6.89793 17.4686 9.85646",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 9.85638C11.2812 12.9986 8.75578 15.5459 5.6407 15.5459C2.52561 15.5459 0 12.9981 0 9.85638C0 6.71469 2.52542 4.16663 5.6407 4.16663C8.75598 4.16663 11.2812 6.71411 11.2812 9.85638Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.5d428da95005eaa5ba701eb406b033fd.svg";
export { ForwardRef as ReactComponent };